<div class="full-page w-100 d-md-flex d-block px-0">
  <!--Left Side-->
  <img class="shared-login-banner d-md-block d-none" draggable="false" src="assets/images/login-registration/login-banner.png" />
  <div class="bg-primary d-flex w-100 d-md-none m-auto mobile-header"></div>
  <!--Right Side-->
  <div class="right-side-login">
    <h4 class="text-primary panel-text font-size-20 fw-bold">
      <p>Attempting to login</p>
      <!-- <fgbcl-loading [size]="'small'"></fgbcl-loading> -->
    </h4>
  </div>
</div>
